[
 {
  "id": "logo",
  "x": 210,
  "y": 30,
  "w": 524,
  "h": 332
 },
 {
  "id": "lang",
  "x": 734,
  "y": 36,
  "w": 184,
  "h": 82
 },
 {
  "id": "btn.google",
  "x": 58,
  "y": 920,
  "w": 826,
  "h": 144
 },
 {
  "id": "btn.apple",
  "x": 58,
  "y": 1068,
  "w": 826,
  "h": 140
 },
 {
  "id": "btn.email",
  "x": 58,
  "y": 1212,
  "w": 826,
  "h": 142
 }
]